<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="@/common/imgs/videos.jpg" alt="">
    </div>

    <!-- content -->
    <div class="vides-content">
      <div class="news-left">
        <dl>
          <dt>
            <h3>视频中心</h3>
            <p>Video Center</p>
          </dt>
          <dd class="w33">
            <router-link to="CoVideos">
              <span>企宣片</span>
              <i class="el-icon-arrow-right"></i>
            </router-link>
          </dd>
          <dd class="w33">
            <router-link to="PjVideos">
              <span>项目片</span>
              <i class="el-icon-arrow-right"></i>
            </router-link>
          </dd>
          <dd class="w33">
            <router-link to="AcVideos" class="active">
              <span>活动片</span>
              <i class="el-icon-arrow-right"></i>
            </router-link>
          </dd>
        </dl>
      </div>
      <div class="news-right">
        <div class="news-bread">
          <h2>视频中心</h2>/<i>活动片</i>
        </div>
        <div class="video-tabs">
          <el-tabs @tab-click="handleClick" type="border-card">
            <div v-show="videoList.length == 0">暂无视频</div>
            <el-tab-pane v-for="item,index in videoList" :label="item.title" :key="item.id">
              <video class="video-js vjs-default-skin"  ref="videoPlayer" controls preload="none" :poster="item.headImage?item.headImage.fileVo.url:''" @play="onPlayerPlay($event,index)" >
                <source :src="item.attachmentVos.length?item.attachmentVos[0].fileVo.url:''" type="video/mp4">
              </video>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'AcVideos',
    data() {
      return {
        url: global_msg.baseUrl,
        playerOptions: [],
        videoList: []
      }
    },
    created() {
    },
    mounted() {
      // 请求视频列表
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=活动片').then((response) => {
        this.videoList = response.data.subject.result;
      });
    },
    methods: {
      //切换tab时触发
      handleClick(tab, event) {
        this.onPlayerPlay(event, tab.index);
      },
      //控制其它视频暂停
      onPlayerPlay(player, index) {
        var that = this.$refs.videoPlayer;
        for (var i = 0; i < that.length; i++) {
          if (i != index) {
            that[i].pause()
          }
        }
      },
      //暂停
      onPlayerPause(player) {
        player.pause();
      }
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    }
  }
</script>
<style scoped="">
  .video-tabs {
    margin: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AcVideos.vue